module.exports = __webpack_public_path__ + "static/img/process-empty.3ceed708.png";